/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/1/2023
 */

export const FileTypesEnum = Object.freeze({
	PDFS: ['.pdf', 'pdf', 'application/pdf'],
	IMAGES: [".png", ".jpg", ".jpeg", ".jfif", ".pjpeg", ".pjp", ".gif", ".ico", ".cur", ".svg", ".apng"]
})
